import { newApp } from './components/App';
import { newUI } from './DashboardUI';

export default function() {
    console.log('DASHBOARDAPP: -- DashboardApp started --------------------------');

    const app = newApp({name: 'DashboardApp'});
    const options = {app};
    console.log('DASHBOARDAPP: creating UI');
    const ui = newUI(options);

    app.registerUI(ui);
    app.start();
}

